(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ecomativesby-collection-product"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ecomativesby-collection-product')) {
    customElements.define(
      'ecomativesby-collection-product',
      class extends HTMLElement {
        connectedCallback() {
          const params = new URLSearchParams(window.location.search);
          this.handle = (params.get('ecomativesby') || '').trim().toLowerCase();
          if (!/^[a-z0-9][a-z0-9-]*$/.test(this.handle)) return;

          this.cardStyle = this.dataset.cardStyle || '1';
          this.section = this.closest('.shopify-section') || this.parentElement;
          this.cardHtml = '';
          this.fetchPromise = null;
          this.pending = false;
          this.clickHandler = this.preserveParameter.bind(this);
          document.addEventListener('click', this.clickHandler, true);

          this.observer = new MutationObserver(() => this.scheduleReconcile());
          this.observer.observe(this.section, { childList: true, subtree: true });
          this.reconcile();
        }

        disconnectedCallback() {
          document.removeEventListener('click', this.clickHandler, true);
          if (this.observer) this.observer.disconnect();
        }

        scheduleReconcile() {
          if (this.pending) return;
          this.pending = true;
          window.requestAnimationFrame(() => {
            this.pending = false;
            this.reconcile();
          });
        }

        preserveParameter(event) {
          const control = event.target.closest(
            '.t4s-active-filters a, [data-filter-links] a, [data-sidebar-links] a, [data-filter-sortby] a, [data-sortby-item], [data-ntjax-wrap] a, [data-ntjax-link], [data-load-more], .t4s-pagination-wrapper a'
          );
          if (!control) return;

          const href = control.getAttribute('href');
          if (href) {
            try {
              const url = new URL(href, window.location.origin);
              if (url.origin === window.location.origin) {
                url.searchParams.set('ecomativesby', this.handle);
                control.setAttribute('href', `${url.pathname}${url.search}${url.hash}`);
              }
            } catch (error) {
              return;
            }
          }
          window.setTimeout(() => this.restoreAddressParameter(), 0);
          window.setTimeout(() => this.restoreAddressParameter(), 400);
        }

        restoreAddressParameter() {
          const url = new URL(window.location.href);
          if (url.searchParams.get('ecomativesby') === this.handle) return;
          url.searchParams.set('ecomativesby', this.handle);
          window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
        }

        getGrid() {
          return this.section.querySelector('[data-ntajax-container] [data-contentlm-replace].t4s-products');
        }

        getHandle(card) {
          const options = card.getAttribute('data-product-options') || '';
          try {
            return String(JSON.parse(options).handle || '').toLowerCase();
          } catch (error) {
            const match = options.match(/"handle"\s*:\s*"([^"]+)"/);
            return match ? match[1].toLowerCase() : '';
          }
        }

        matchingCards(grid) {
          return Array.from(grid.children).filter(
            (card) => card.matches('.t4s-product') && this.getHandle(card) === this.handle
          );
        }

        reconcile() {
          const grid = this.getGrid();
          if (!grid) return;

          this.restoreAddressParameter();
          const matches = this.matchingCards(grid);
          if (matches.length) {
            const canonical = matches.find((card) => card.hasAttribute('data-ecomativesby-promoted')) || matches[0];
            let changed = matches.length > 1 || grid.firstElementChild !== canonical;
            canonical.setAttribute('data-ecomativesby-promoted', '');
            if (!this.cardHtml) this.cardHtml = canonical.outerHTML;
            matches.forEach((card) => {
              if (card !== canonical) card.remove();
            });
            if (grid.firstElementChild !== canonical) grid.prepend(canonical);
            if (changed) this.refreshGrid(grid);
            return;
          }

          if (this.cardHtml) {
            this.insertCard(grid, this.cardHtml);
            return;
          }

          this.fetchCard().then((html) => {
            const currentGrid = this.getGrid();
            if (html && currentGrid && !this.matchingCards(currentGrid).length) {
              this.cardHtml = html;
              this.insertCard(currentGrid, html);
            } else if (currentGrid && this.matchingCards(currentGrid).length) {
              this.reconcile();
            }
          });
        }

        fetchCard() {
          if (this.fetchPromise) return this.fetchPromise;
          const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
          const url = `${root}products/${encodeURIComponent(this.handle)}?view=ecomativesby`;

          this.fetchPromise = fetch(url, { credentials: 'same-origin' })
            .then((response) => (response.ok ? response.text() : ''))
            .then((markup) => {
              if (!markup) return '';
              const responseDocument = new DOMParser().parseFromString(markup, 'text/html');
              const escapedStyle = window.CSS && CSS.escape ? CSS.escape(this.cardStyle) : this.cardStyle;
              const template = responseDocument.querySelector(
                `template[data-ecomativesby-card="${escapedStyle}"]`
              );
              const card = template && template.content.querySelector('.t4s-product');
              return card && this.getHandle(card) === this.handle ? card.outerHTML : '';
            })
            .catch(() => '');
          return this.fetchPromise;
        }

        insertCard(grid, html) {
          const template = document.createElement('template');
          template.innerHTML = html.trim();
          const card = template.content.querySelector('.t4s-product');
          if (!card || this.getHandle(card) !== this.handle) return;

          card.setAttribute('data-ecomativesby-promoted', '');
          grid.prepend(card);
          this.matchingCards(grid).forEach((match) => {
            if (match !== card) match.remove();
          });
          this.refreshGrid(grid);
        }

        refreshGrid(grid) {
          window.setTimeout(() => {
            if (window.T4SThemeSP && typeof window.T4SThemeSP.reinitProductGridItem === 'function') {
              window.T4SThemeSP.reinitProductGridItem();
            }
            if (
              grid.classList.contains('isotopet4s-enabled') &&
              window.jQuery_T4NT &&
              typeof window.jQuery_T4NT(grid).isotopet4s === 'function'
            ) {
              window.jQuery_T4NT(grid).isotopet4s('reloadItems').isotopet4s('layout');
            }
          }, 0);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
